import { Link } from "react-router-dom";
import NewsCard from "../../../../Components/NewsCard/NewsCard";
import { useTranslation } from "../../../../i18n/LanguageProvider";
import Title from "../Title/Title";
import "../../../News/News.sass";

function NewsSection({ news }) {
    const { t, localizedPath } = useTranslation();

    if (!news || news.length === 0) {
        return null;
    }

    return (
        <section className="home-news" aria-labelledby="home-news-title">
            <Title id="home-news-title" text={t("news.title")} />
            <div className="news__grid home-news__grid">
                {news.map((item) => (
                    <NewsCard key={item.id} news={item} />
                ))}
            </div>
            <div className="home-news__more">
                <Link to={localizedPath("/noutati")}>{t("news.allNews")}</Link>
            </div>
        </section>
    );
}

export default NewsSection;
